import { Component, OnInit, Input, Output } from '@angular/core';
import { finalize, tap } from 'rxjs/operators';
import { AngularFirestore } from '@angular/fire/firestore';
import { AngularFireStorage, AngularFireUploadTask } from '@angular/fire/storage';
import { Observable } from 'rxjs';
import { FileFirebaseUpload } from '../../models/fileFirebaseUpload.model';
import { FileSizePipe } from '../../uploads/file-size.pipe';

@Component({
  selector: 'app-upload',
  templateUrl: './upload.component.html',
  styleUrls: ['./upload.component.scss']
})
export class UploadComponent {

  @Input() title: string;
  @Input() subTitle: string;
  @Input() btnText: string;
  @Input() notSelectedFileText: string;
  @Input() chooseText: string;
  @Input() onlyImages = false;
  @Input() onlyPDF = false;
  @Input() onlyGPX = false;
  @Input() onlyOneFile = false;
  @Input() files: FileFirebaseUpload[];
  // State for dropzone CSS toggling
  isHovering: boolean;

  constructor(
    private storage: AngularFireStorage,
    private db: AngularFirestore) {
  }

  toggleHover(event: boolean) {
    this.isHovering = event;
  }

  selectedFile(event: FileList) {
    if (event.length > 1 && this.onlyOneFile) {
        return;
    }
    for (let i = 0; i < event.length; i++) {
      const element = event.item(i);
      if (this.onlyImages && element.type.split('/')[0] !== 'image') {
        continue;
      } if (this.onlyPDF && element.type !== 'application/pdf') {
        continue;
      } if (this.onlyGPX && !element.name.endsWith('.gpx')) {
        continue;
      } else {
        const f = new FileFirebaseUpload();
        f.name = element.name;
        f.type = element.type;
        f.file = element;
        f.toSend = true;
        this.files.push(f);
        this.startUpload(f, this.onlyImages, 'files');
      }
    }
  }

  startUpload(file: FileFirebaseUpload, onlyImages: boolean, collection: string) {

    // Client-side validation example
    if (onlyImages && file.file.type.split('/')[0] !== 'image') {
      return;
    }
    if (this.onlyPDF && file.file.type !== 'application/pdf') {
      return;
    }
    if (this.onlyGPX && !file.file.name.endsWith('.gpx')) {
      return;
    }
    // The storage path
    file.name = file.file.name;
    const id = `${new Date().getTime()}_${file.file.name}`;
    const path = `${collection}/${id}`;

    // Totally optional metadata
    const customMetadata = { origin: 'Web', docType: file.file.type };

    // The main task
    file.task = this.storage.upload(path, file.file, { customMetadata });
    file.path = path;
    file.id = id;
    file.realName = id;
    // Progress monitoring
    file.percentage = file.task.percentageChanges();
    file.snapshot = file.task.snapshotChanges().pipe(
      tap(snap => {
        if (snap.bytesTransferred === snap.totalBytes) {
          // Update firestore on completion
          // this.db.collection(collection).add({ path, size: snap.totalBytes });
        }
      }),
      finalize(() => {
        try {
          file.downloadURL = this.storage.ref(path).getDownloadURL();
          file.downloadURL.subscribe(data => file.url = data );
          file.upload = true;
        } catch (error) {
          file.upload = false;
        }
       })
    );
  }
  // Determines if the upload task is active
  isActive(snapshot) {
    return (
      snapshot.state === 'running' &&
      snapshot.bytesTransferred < snapshot.totalBytes
    );
  }
  deleteFile(f) {
    const index: number = this.files.indexOf(f);
    if (index !== -1) {
        this.files.splice(index, 1);
    }
  }
  removeFileFirestore(f) {
    // TODO
  }
}
